import Icon from "rc-app/components/Icons";
import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import UserService from "rc-app/services/UserService";

const ClientHomePage: React.FC = () => {
  const navigate = useNavigate();
  const { slug } = useParams<{ slug: string }>();
  const base = slug ? `/c/${slug}` : "";

  useEffect(() => {
    if (slug) localStorage.setItem("agencySlug", slug);
  }, [slug]);

  // Role-based tiles (per the role matrix):
  //   ABA      → Projects · System Admins · Agents · Leads · Analytics · Profile
  //   ASA      → Projects · Agents · Leads · Analytics · Profile
  //   Agent    → Projects · Leads · Analytics · Profile
  //   Customer → Projects · Analytics (share-only, enforced in AnalyticsV3) · Profile
  // super_admin is treated like ABA (sees everything).
  const isSuper = UserService.hasRole("super_admin");
  const isABA = UserService.hasRole("agency_business_admin");
  const isASA = UserService.hasRole("agency_system_admin");
  const isAgent = UserService.hasRole("agent");
  const canSeeSystemAdmins = isABA || isSuper;
  const canSeeAgents = isABA || isASA || isSuper;
  const canSeeLeads = isABA || isASA || isAgent || isSuper;

  const menuItems = [
    {
      title: "Projects",
      icon: "ic-client-projects",
      path: `${base}/p/library`,
      show: true,
    },
    {
      title: "System Admins",
      icon: "ic-client-system-admins",
      path: `${base}/system-admins`,
      show: canSeeSystemAdmins,
    },
    {
      title: "Agents",
      icon: "ic-client-agents",
      path: `${base}/agents`,
      show: canSeeAgents,
    },
    {
      title: "Leads",
      icon: "ic-client-customers",
      path: `${base}/leads`,
      show: canSeeLeads,
    },
    {
      title: "Analytics",
      icon: "ic-client-analytics",
      path: `${base}/analytics`,
      show: true,
    },
    {
      title: "Profile",
      icon: "ic-client-profile",
      path: `${base}/profile`,
      show: true,
    },
  ].filter((i) => i.show);

  return (
    <div className="min-h-[calc(100dvh-64px)] bg-gradient-to-b from-[#1C2C3A] to-[#1E4F52] flex flex-col">
      {/* <div className="container mx-auto px-4 py-6 md:px-8 md:py-12">
        <h2 className="text-white text-xl md:text-3xl font-bold mb-4 md:mb-6 text-center">
          Experience 360° Virtual Tour
        </h2>
        <div
          style={{
            position: "relative",
            paddingBottom: "56.25%",
            height: 0,
            overflow: "hidden",
            borderRadius: "12px",
          }}
        >
          <iframe
            src="https://player.vimeo.com/video/1183771313?autoplay=0&title=1&byline=0&portrait=0"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; gyroscope; accelerometer; xr-spatial-tracking"
            allowFullScreen
            title="360° Virtual Tour"
          />
        </div>
      </div> */}

      {/* Hero Section */}
      <div className="flex-shrink-0 flex flex-col md:flex-row px-4 pt-6 pb-5 md:py-2 md:h-[300px] bg-[#222F3C] items-center justify-between">
        <div className="flex flex-col w-full md:w-auto justify-center gap-2 md:gap-4">
          <div className="max-w-2xl">
            <h1 className="text-white text-lg md:text-3xl lg:text-5xl font-semibold mb-1 md:mb-4 leading-tight">
              HELPING YOU MANAGE
              <br />
              YOUR PROJECTS
            </h1>
            <p className="text-white text-xs md:text-xl font-medium">
              The one stop place to manage your properties
            </p>
          </div>
        </div>

        {/* static image */}
        <div className="hidden md:block h-full w-1/2 max-w-[740px] rounded-t-lg">
          <img
            src={`${process.env.REACT_APP_UPLOADED_URL}/realestate/client-home-hero.jpg`}
            alt="Buildings"
            className="w-full h-full object-cover overflow-hidden rounded-t-lg"
          />
        </div>
      </div>
      {/* Menu Cards */}
      <div className="flex-1 min-h-0 container mx-auto px-4 py-5 md:py-3 md:px-8 flex items-start md:items-center">
        {/* Centered flex: each tile keeps the 6-up width per breakpoint, so a
            full set fills the row exactly and a smaller set (ASA/agent/customer)
            sits centered with equal margins instead of leaning left. */}
        <div className="w-full flex flex-wrap justify-center gap-3 md:gap-6">
          {menuItems.map((item) => (
            <div
              key={item.title}
              onClick={() => navigate(item.path)}
              className="grow-0 shrink-0 basis-[calc((100%_-_0.75rem)/2)] md:basis-[calc((100%_-_3rem)/3)] lg:basis-[calc((100%_-_7.5rem)/6)] border-2 border-[#FFFFFF] rounded-2xl p-3 md:p-5 cursor-pointer hover:bg-[#254555] transition-all flex flex-col items-center justify-center"
            >
              <div className="w-12 h-12 md:w-24 md:h-24 mb-1.5 md:mb-3">
                <Icon name={item.icon} className="w-full h-full" />
              </div>
              <h3 className="text-white text-sm md:text-lg font-medium text-center">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientHomePage;
